import React from 'react';
import {hot} from 'react-hot-loader';
import {Provider} from 'react-redux';
import {BrowserRouter, Route} from 'react-router-dom';
import AppContainer from './components/AppContainer/AppContainer';
import LeadAppContainer from './components/LeadAppContainer/LeadAppContainer';
import BillingSetupContainer from "./components/BillingSetupContainer/BillingSetupContainer";
import {LocalizationContextProvider} from '@homeaway/react-localization-components';

/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */
function Root({store}) {
    return (
        <Provider store={store}>
            <LocalizationContextProvider siteContext={window.__SITE_CONTEXT__}>
                <BrowserRouter basename={window.__SITE_CONTEXT__.basePath}>
                    <Route path='/p/onboard' component={AppContainer}/>
                    <Route path='/t/onboard/traveler' component={AppContainer}/>
                    <Route path='/p/taxInfo' component={BillingSetupContainer}/>
                    <Route path='/p/pm-intake' component={LeadAppContainer}/>
                </BrowserRouter>
            </LocalizationContextProvider>
        </Provider>
    );
}

export default hot(module)(Root);
